import React, { Component } from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

import API from '../api'
import Auth from '../auth'
import settings from '../settings'

import PayPalButton from '../components/PaypalButton'
import Popup from '../components/Popup'

import basic from '../static/img/package-basic.svg'
import plus from '../static/img/package-plus.svg'
import pro from '../static/img/package-pro.svg'
import corporate from '../static/img/package-corporate.svg'


const handlePromoError = (code, status, displayMessage) => {
  if (status === 404) {
    displayMessage(
      <div> 
        The promotional code <strong>{code}</strong> does not exist or it is expired. <br/>
        Try with a different one. 
      </div>
    )
  } else if (status === 410) {
    displayMessage(
      <span> The promotional code <strong>{code}</strong> was already used.</span>
    )
  }
}


class ApplyPromo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      code: undefined,
    }
  }

  handleApply = () => {
    const token = Auth.getToken()
    if (!token) {
      this.props.goToLogin()
    }

    if (!this.state.code) {
      return
    }

    API.getPromo(this.state.code).then(resp =>  {
      if (resp.ok) {
        return resp.json()
      } else {
        throw resp
      }
    }).then(promo => {
      this.props.onApply(promo)
    }).catch(
      resp => handlePromoError(this.state.code, resp.status, this.props.displayMessage)
    )
  }

  handleCodeChange = e => {
    this.setState({ code: e.target.value })
  }

  render() {
    return (
      <div className="promo-apply">
        <input
          placeholder="Promotional code"
          value={this.state.code}
          onChange={this.handleCodeChange}
        />
        <button onClick={this.handleApply}> Apply </button>
      </div>
    )
  }
}


class PromoDiscount extends Component {
  constructor(props) {
    super(props)
    this.state = this.loadPlans(props.promo)
  }

  componetWillReceiveProps(nextState, nextProps) {
    this.setState(this.loadPlans(nextProps.promo))
  }

  loadPlans = promo => {
    let defaultPlans = []
    for (const [id, plan] of Object.entries(settings.PLANS)) {
      defaultPlans.push({
        value: id,
        label: `${plan.name} - ${plan.description}`,
      })
    }

    const plans = defaultPlans.filter(p => promo.plans.includes(p.value))

    return { plans: plans, selectedPlan: plans[0].value }
  }

  onSelectPlan = plan => this.setState({ selectedPlan: plan.value })

  render() {
    const { promo } = this.props

    const plan = settings.PLANS[this.state.selectedPlan]
    const discount = plan.price / 100 * promo.discount
    const total = plan.price - discount

    const description = (
      `${plan.description} with ${promo.discount}% discount by ${promo.name}`
    )

    return (
      <div className="promo">
        <div className="promo-title"> Promotional code </div>
        <div className="promo-description">
          {promo.discount}% discount only for {promo.name} clients!
        </div>
        <div className="promo-select-plan">
          <Select
            value={this.state.selectedPlan}
            onChange={this.onSelectPlan}
            removedSelected={false}
            options={this.state.plans}
          />
        </div>
        <div className="promo-details">
          <div className="promo-row promo-subtotal">
            <div className="name"> Subtotal </div>
            <div className="desc"> {plan.name} plan </div>
            <div className="value"> ${plan.price} </div>
          </div>
          <div className="promo-row promo-discount">
            <div className="name"> Discount </div>
            <div className="desc"> {promo.discount}% by {promo.reseller} </div>
            <div className="value"> ${discount} </div>
          </div>
          <div className="promo-row promo-total">
            <div className="name"> Total </div>
            <div className="desc"> </div>
            <div className="value"> ${total} </div>
          </div>
        </div>
        <div className="promo-paypal-btn">
          <PayPalButton
            plan={this.state.selectedPlan}
            price={total}
            description={description}
            promoCode={promo.code}
            displayMessage={this.props.displayMessage}
          />
        </div>
      </div>
    )
  }
}


class PromoGift extends Component {
  onAccept = () => {
    const { code, gift_amount } = this.props.promo
    API.applyPromo(code).then(resp => {
      if (resp.ok) {
        this.props.displayMessage(
          <span> <strong>{gift_amount}</strong> FrameALIVEs were sucessfully added to your account!</span>
        )
      } else {
        throw resp
      }
    }).catch(
      resp => handlePromoError(code, resp.status, this.props.displayMessage)
    )    
  }

  render() {
    const { promo } = this.props
    return (
      <div className="promo">
        <div className="promo-title"> Promotional code </div>
        <div className="promo-description">
          {`${promo.name} gives you ${promo.gift_amount} FrameALIVEs!`}
        </div>
        <div className="promo-gift-btn">
          <button onClick={this.onAccept}> Accept </button>
        </div>
      </div>
    )
  }
}


export default class PlansPage extends Component {
  displayMessage = m => this.popup.show(m, true)

  processPromoApply = promo => {
    if (promo.type === 'discount') {
      this.popup.show(<PromoDiscount promo={promo} displayMessage={this.displayMessage} />, true)
    } else if (promo.type === 'gift') {
      this.popup.show(<PromoGift promo={promo} displayMessage={this.displayMessage} />, true)
    }
  }

  render() {
    return (
      <header className="demomasthead">
        <div className="header-content" style={{marginTop: '110px'}}>
          <div className="header-content-inner plans">
            <div className="row">
              <div className="col col-lg-3">
                <ul className="list-group plan-item">
                  <li className="list-group-item flex-column noborder noBorderLine" style={{height: '90px'}}>
                    <img className="plan-icon" src={basic} alt="" />
                  </li>
                  <li className="list-group-item flex-column noborder noBorderLine">
                    <div className="name">Basic</div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="description">
                      <div className="count">
                        <strong> 1 </strong> <br/>
                        FrameALIVE
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item flex-column noBorder noBorderLine">
                    <div className="price"> $8 </div>
                  </li>
                  <PayPalButton plan='basic' displayMessage={this.displayMessage} />
                </ul>
              </div>
              <div className="col col-lg-3">
                <ul className="list-group plan-item">
                  <li className="list-group-item flex-column noborder noBorderLine" style={{height: '90px'}}>
                    <img className="plan-icon" src={plus} alt="" />
                  </li>
                  <li className="list-group-item flex-column noborder noBorderLine">
                    <div className="name">Plus</div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="description">
                      <div className="count">
                        <strong> 30 </strong> <br/>
                        FrameALIVEs
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="price">
                      $75
                    </div>
                  </li>
                  <PayPalButton plan='plus' displayMessage={this.displayMessage} />
                </ul>
              </div>
              <div className="col col-lg-3">
                <ul className="list-group plan-item">
                  <li className="list-group-item flex-column noborder noBorderLine" style={{height: '90px'}}>
                    <img className="plan-icon" src={pro} alt="" />
                  </li>
                  <li className="list-group-item flex-column noborder noBorderLine">
                    <div className="name">Professional</div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="description">
                      <div className="count">
                        <strong> 120 </strong> <br/>
                        FrameALIVEs
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="price">
                      $190
                    </div>
                  </li>
                  <PayPalButton plan='professional' displayMessage={this.displayMessage} />
                </ul>
              </div>
              <div className="col col-lg-3">
                <ul className="list-group plan-item">
                  <li className="list-group-item flex-column noborder noBorderLine" style={{height: '90px'}}>
                    <img className="plan-icon" src={corporate} alt="" />
                  </li>
                  <li className="list-group-item flex-column noborder noBorderLine" style={{marginBottom: '-3px'}}>
                    <div className="name corporate"> Corporate </div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="description">
                      <div className="count">
                      </div>
                      <div> Have any questions? </div>
                    </div>
                  </li>
                  <li className="list-group-item flex-column noBorderLine">
                    <div className="price">
                    </div>
                  </li>
                  <a href="mailto:info@framealive.com"><div id="btnContactUs" className="btn">Contact us</div></a>
                </ul>
              </div>
            </div>
            <div className="row">
              <ApplyPromo
                onApply={this.processPromoApply}
                displayMessage={this.displayMessage}
                goToLogin={() => this.props.history.push('/login')}
              />
            </div>
            <div className="row">
              <div className="plans-note">
                By making this purchase, you authorize FrameALIVE Inc to charge your credit,<br/>
                debit card, or PayPal account  and agree to our Terms and Conditions. <br/>
                Price in USD. 
              </div>
            </div>
          </div>
        </div>
        <Popup ref={r => this.popup = r} />
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PlansPage.js